"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _setSendBox = require("../actions/setSendBox");

var _setSendTyping = require("../actions/setSendTyping");

var _setSendTypingIndicator = require("../actions/setSendTypingIndicator");

var _postActivity = _interopRequireWildcard(require("../actions/postActivity"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _sendTypingIndicator = _interopRequireDefault(require("../selectors/sendTypingIndicator"));

var _sleep = _interopRequireDefault(require("../utils/sleep"));

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(_callee),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(sendTypingIndicatorOnSetSendBox);

var SEND_INTERVAL = 3000;

function takeSendTypingIndicator(value) {
  return (0, _effects.take)(function (_ref) {
    var payload = _ref.payload,
        type = _ref.type;
    return type === _setSendTypingIndicator.SET_SEND_TYPING_INDICATOR && !payload.sendTypingIndicator === !value || // TODO: [P3] Take this deprecation code out when releasing on or after January 13 2020
    type === _setSendTyping.SET_SEND_TYPING && !payload.sendTyping === !value;
  });
}

function _callee() {
  return _regenerator["default"].wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _whileConnected["default"])(sendTypingIndicatorOnSetSendBox);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function sendTypingIndicatorOnSetSendBox() {
  var sendTypingIndicator, _loop;

  return _regenerator["default"].wrap(function sendTypingIndicatorOnSetSendBox$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_sendTypingIndicator["default"]);

        case 2:
          sendTypingIndicator = _context4.sent;

          if (sendTypingIndicator) {
            _context4.next = 6;
            break;
          }

          _context4.next = 6;
          return takeSendTypingIndicator(true);

        case 6:
          _loop =
          /*#__PURE__*/
          _regenerator["default"].mark(function _loop() {
            var lastSend, task;
            return _regenerator["default"].wrap(function _loop$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    lastSend = 0;
                    _context3.next = 3;
                    return (0, _effects.takeLatest)(function (_ref2) {
                      var payload = _ref2.payload,
                          type = _ref2.type;
                      return type === _setSendBox.SET_SEND_BOX && payload.text || // Stop sending pending typing indicator if the user has posted anything.
                      // We send typing indicator in a debounce way (t = 0, t = 3000, t = 6000).
                      // When the user type, and then post the activity at t = 1500, we still have a pending typing indicator at t = 3000.
                      // This code is to cancel the typing indicator at t = 3000.
                      type === _postActivity.POST_ACTIVITY && payload.activity.type !== 'typing';
                    },
                    /*#__PURE__*/
                    _regenerator["default"].mark(function _callee2(_ref3) {
                      var type, interval;
                      return _regenerator["default"].wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              type = _ref3.type;

                              if (!(type === _setSendBox.SET_SEND_BOX)) {
                                _context2.next = 9;
                                break;
                              }

                              interval = SEND_INTERVAL - Date.now() + lastSend;

                              if (!(interval > 0)) {
                                _context2.next = 6;
                                break;
                              }

                              _context2.next = 6;
                              return (0, _effects.call)(_sleep["default"], interval);

                            case 6:
                              _context2.next = 8;
                              return (0, _effects.put)((0, _postActivity["default"])({
                                type: 'typing'
                              }));

                            case 8:
                              lastSend = Date.now();

                            case 9:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                  case 3:
                    task = _context3.sent;
                    _context3.next = 6;
                    return takeSendTypingIndicator(false);

                  case 6:
                    _context3.next = 8;
                    return (0, _effects.cancel)(task);

                  case 8:
                    _context3.next = 10;
                    return takeSendTypingIndicator(true);

                  case 10:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _loop);
          });

        case 7:
          return _context4.delegateYield(_loop(), "t0", 8);

        case 8:
          _context4.next = 7;
          break;

        case 10:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2);
}